/**
 * Utilitaires monétaires — tous les montants sont en centimes (integer).
 * Aucun float ne doit circuler entre services.
 */

/** Convertit un montant décimal en centimes (integer). */
export const toCents = (amount: number): number => Math.round(amount * 100);

/** Convertit des centimes en montant décimal pour affichage. */
export const fromCents = (cents: number): number => cents / 100;

/** Applique une remise en pourcentage (0-100) sur un montant en centimes. */
export function applyDiscountPct(cents: number, pct: number): number {
  if (pct < 0 || pct > 100) {
    throw new RangeError(`Remise en pourcentage invalide : ${pct}. Doit être entre 0 et 100.`);
  }
  return Math.round(cents * (1 - pct / 100));
}

/** Applique une remise fixe en centimes. */
export function applyDiscountFixed(cents: number, discountCents: number): number {
  if (discountCents < 0) {
    throw new RangeError(`Remise fixe invalide : ${discountCents}. Doit être >= 0.`);
  }
  if (discountCents > cents) {
    throw new RangeError(`Remise fixe (${discountCents}) supérieure au montant (${cents}).`);
  }
  return Math.max(0, cents - discountCents);
}

/** Division arrondie pour prix unitaire effectif. */
export const divideRound = (cents: number, qty: number): number => Math.round(cents / qty);

/** Somme de montants en centimes. */
export const sumCents = (items: number[]): number => items.reduce((acc, v) => acc + v, 0);

/** Formate un montant en centimes pour affichage (ex: 1299 → "12.99"). */
export const formatCents = (cents: number): string => (cents / 100).toFixed(2);
